// extracted by mini-css-extract-plugin
export default {"header-3":"g__header-3--LAFlA","header-2":"g__header-2--o2YwU","header-1":"g__header-1--gIpe5","similar-properties-container":"g__similar-properties-container--cdxtX"};